import { createContext, useContext } from "react";
import { useInitialEvaluation } from "./useInitialEvaluation";
import type { MemberFinalStatus } from "../api/scoring-api";
import type { SupplierEvaluationSummary } from "../types/scoring.type";

interface InitialEvaluationContextValue {
	allSuppliersScored: boolean;
	error: string | null;
	isLoading: boolean;
	memberFinalStatus: MemberFinalStatus;
	memberFinalSubmittedAt: string | null;
	notPermitted: boolean;
	readOnly: boolean;
	submittedAt: string | null;
	suppliers: SupplierEvaluationSummary[];
	fetchSuppliers: () => Promise<void>;
	refreshSupplier: (inviteId: number) => void;
}

const InitialEvaluationContext = createContext<InitialEvaluationContextValue | null>(null);

interface InitialEvaluationProviderProps {
	children: React.ReactNode;
	rfxId: number | undefined;
}

export const InitialEvaluationProvider: React.FC<InitialEvaluationProviderProps> = ({
	rfxId,
	children,
}) => {
	const value = useInitialEvaluation({ rfxId });

	return (
		<InitialEvaluationContext.Provider value={value}>
			{children}
		</InitialEvaluationContext.Provider>
	);
};

export const useInitialEvaluationContext = (): InitialEvaluationContextValue => {
	const context = useContext(InitialEvaluationContext);
	if (!context) {
		throw new Error("useInitialEvaluationContext must be used within an InitialEvaluationProvider");
	}
	return context;
};
